import { Component, HostListener, NgModule } from "@angular/core";
import { SpinnerService } from "./services/spinner.service";

import { Subject } from "rxjs";
import { timer } from "rxjs/observable/timer";

import { takeUntil } from "rxjs/operators";
import { Router, ActivatedRoute, RouterLinkActive } from "@angular/router";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
})
@NgModule({
  declarations: [AppComponent],
})
export class AppComponent {
  userActivity;

  userInactive: Subject<any> = new Subject();
  title = "Espire";
  loading: any;
  constructor(public spinnerService: SpinnerService, private router: Router) {
    this.loading = false;
    this.setTimeout();
    this.userInactive.subscribe(() => {
      this.onLogout();
      console.log("user has been inactive for 10mins");
    });
  }

  setTimeout() {
    this.userActivity = setTimeout(
      () => this.userInactive.next(undefined),
      600000
    );
  }

  // @HostListener("window:mousemove") onMouseMove() {
  //   clearTimeout(this.userActivity);
  //   this.setTimeout();
  // }

  // @HostListener("window:keypress")
  // onKeyPress() {
  //   clearTimeout(this.userActivity);
  //   this.setTimeout();
  // }
  @HostListener("window:mousemove")
  @HostListener("window:mousedown")
  @HostListener("window:keydown")
  @HostListener("window:scroll")
  onUserActivity() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  onLogout() {
    const userId = localStorage.getItem("created_by");
    const dash = localStorage.getItem("dash");
    localStorage.clear();
    localStorage.setItem("created_by", userId || "");
    localStorage.setItem("dash", dash || "");
    this.router.navigateByUrl("/authentication/sign-in");
  }
}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/app.component.ts